import axios from "axios";
import Cookies from "js-cookie";

const axiosinstance = axios.create({
    baseURL:process.env.REACT_APP_AXIOS_URL

});

// Attach the auth token (JWT stored in the `uid` cookie) to EVERY request so the
// server can derive the caller's identity from the verified token instead of a
// forgeable user_id sent in the body/headers. Purely additive and backward-
// compatible:
//   - if a call already set its own Authorization (e.g. the admin token), we
//     never override it;
//   - if there's no token yet (logged-out, or login/register/otp calls), we
//     send nothing, so those flows are unaffected.
axiosinstance.interceptors.request.use((config) => {
    const token = Cookies.get("uid");
    const hasAuth = config.headers?.Authorization || config.headers?.authorization;
    if (token && !hasAuth) {
        config.headers = config.headers || {};
        config.headers.Authorization = token;
    }
    return config;
});

export default axiosinstance;
